import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { SELECT_PAGOS } from '@/utils/constants'

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    dashboardData: {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
      F: 0,
      G: 0,
      H: 0,
      I: 0
    },
    dashboardDataTurno: {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
      F: 0,
      G: 0,
      H: 0,
      I: 0
    },
    entradas: 0,
    salidas: 0,
    entradasTurno: 0,
    salidasTurno: 0,
    salidasCudre: 0,
    entradasTotalCudre: 0,
    salidasTotalCudre: 0
  }),
  actions: {
    async fetchDashboardData() {
      try {
        const response = await api.post('/dashboard', {
          // headers: {
          //   Authorization: `Bearer ${getToken()}`
          // },
          pagos: SELECT_PAGOS
        })
        // console.log('DASHBOARD', response.data)
        this.dashboardData = response.data
        this.entradas = this.dashboardData.A + this.dashboardData.B
        this.salidas =
          this.dashboardData.C +
          this.dashboardData.D +
          this.dashboardData.E +
          this.dashboardData.F

        this.entradasTotalCuadre = this.dashboardData.E
        this.salidasTotalCuadre = this.dashboardData.G + this.dashboardData.H
        // this.dashboardData.G +
        // this.dashboardData.H
        return this.dashboardData
      } catch (error) {
        console.error('Error fetching dashboard data:', error)
        throw error
      }
    },
    async fetchDashboardDataTurno() {
      try {
        const response = await api.post('/dashboard/turno', {
          // headers: {
          //   Authorization: `Bearer ${getToken()}`
          // },
          pagos: SELECT_PAGOS
        })
        // console.log('DASHBOARD', response.data)
        this.dashboardDataTurno = response.data
        this.entradasTurno =
          this.dashboardDataTurno.A + this.dashboardDataTurno.B
        this.salidasTurno =
          this.dashboardDataTurno.C +
          this.dashboardDataTurno.D +
          this.dashboardDataTurno.E +
          this.dashboardDataTurno.F +
          // this.dashboardData.G +
          this.dashboardDataTurno.H
        return this.dashboardDataTurno
      } catch (error) {
        console.error('Error fetching dashboard data turno:', error)
        throw error
      }
    }
  }
})
